import { Badge } from 'components/VehicleBadges/types';

export interface BadgeData {
  vehicleIsHot: boolean;
  vehicleHasRecentPriceDrop: boolean;
  vehicleWasRecentlyListed: boolean;
}

export const getVdpBadges = ({
  vehicleIsHot,
  vehicleHasRecentPriceDrop,
  vehicleWasRecentlyListed,
}: BadgeData): Badge[] => {
  const badges = [];

  if (vehicleIsHot) {
    badges.push(Badge.hotCarBadge);
  } else if (vehicleHasRecentPriceDrop) {
    badges.push(Badge.priceDropBadge);
  } else if (vehicleWasRecentlyListed) {
    badges.push(Badge.freshBadge);
  }

  return badges;
};
